import { createDictionaryApiFactory, mapDictionaryState } from "./dictionaryApiFactory";

export const mapToImprovementPlanOrigin = mapDictionaryState;

const improvementPlanOriginApi = createDictionaryApiFactory("improvementPlanOrigin");

export const getImprovementPlanOrigin = improvementPlanOriginApi.search;
